// The Time Bank card: one piece of art used wherever time bank cards are shown (store, wallet, seat, rail button).
// nginx caches /assets for 30 days — if the art is redrawn, bump the -vN filename or browsers keep the old one.
export const TimeBankCard = ({ h = 20, className = "" }) => (
  <img src="/assets/store/timebank-v2.png" alt="" aria-hidden="true" style={{ height: h }}
    className={`w-auto object-contain drop-shadow-[0_2px_4px_rgba(0,0,0,0.6)] ${className}`} />
);
